export default {
    permissionUnitsTitle: 'عنوان ',
    permissionUnitsEn: 'عنوان لاتین',
    permissionUnitsKey: ' شناسه',
}